export const money = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

export const shortId = (id) => (id ? String(id).slice(-6).toUpperCase() : '—');

export const dateStr = (d) => (d ? new Date(d).toLocaleDateString() : '—');
export const dateTimeStr = (d) => (d ? new Date(d).toLocaleString() : '—');

export function ageLabel(hours) {
  if (hours == null) return '';
  if (hours < 1) return 'just now';
  if (hours < 24) return `${Math.round(hours)}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

export const statusVariant = (s) => {
  const v = String(s || '').toLowerCase();
  if (['paid', 'approved', 'confirmed', 'received', 'resolved', 'refunded', 'completed'].includes(v)) return 'success';
  if (['rejected', 'failed', 'cancelled'].includes(v)) return 'danger';
  if (['escalated', 'overdue'].includes(v)) return 'warning';
  return 'secondary';
};

export const severityVariant = (s) => ({ overdue: 'danger', imminent: 'warning' }[s] || 'secondary');
